import { DataListState } from '../data-list.state';
import { createSelector } from '@ngrx/store';
import { auth } from '../auth/auth.selectors';
import { CustomerDto } from '@careapp-group/ng-sdk-v2-new';

export const getMemberCustomersState = (state: { memberCustomers: DataListState<CustomerDto> }) =>
  state.memberCustomers;

export const getOwnCustomers = createSelector(
  auth.getLoggedInUser,
  getMemberCustomersState,
  (user, state) => {
    if (!user || !state.paginators[user.id] || !state.paginators[user.id].ids) {
      return [];
    }
    return state.paginators[user.id].ids.map((id) => state.entities[id]);
  }
);

export const getOwnCustomerPermissions = createSelector(getOwnCustomers, (customers) => {
  return customers.map((customer) =>
    customer.permissions.filter((p) => p.enabled == true && p.modelName == 'Customer')
  );
});
